var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { styling: "page-title", level: 2 } }, [
        _vm._v("Prinzenpaare der Ehrengarde"),
      ]),
      _c("Separator"),
      _c("div", { attrs: { id: "prinzenpaare" } }, [
        _c(
          "div",
          { staticClass: "prinzenpaar" },
          [
            _c("TopicHeader", {
              attrs: {
                id: "michaela_markus",
                src: _vm.michaelaMarkus,
                title: "Prinzenpaar 2019/2020",
              },
            }),
            _c(
              "div",
              { staticClass: "titel" },
              [
                _c(
                  "ParagraphWide",
                  [
                    _vm._v(
                      " Ex-Prinz Markus - Die spitze Feder von der Ehrengarde "
                    ),
                    _c("ParagraphWide"),
                    _vm._v(
                      " Ex-Prinzessin Michaela vom Römerkastell am Wiedesstrand "
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("Separator"),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "prinzenpaar" },
          [
            _c("TopicHeader", {
              attrs: {
                id: "ulrike_gerd",
                src: _vm.ulrikeGerd,
                title: "Prinzenpaar 2008/2009",
              },
            }),
            _c(
              "div",
              { staticClass: "titel" },
              [
                _c("ParagraphWide", [
                  _vm._v(
                    " Ex-Prinz Gerd I vom Hause Neoweda, Herr von Langendorf und Sonnenland "
                  ),
                ]),
                _c("ParagraphWide", [
                  _vm._v(
                    " Ex-Prinzessin Ulrike II von Landsberg / Kettwig zu Rhenania Neoweda Comtesse de Coiffeur "
                  ),
                ]),
              ],
              1
            ),
            _c("Separator"),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "prinzenpaar" },
          [
            _c("TopicHeader", {
              attrs: {
                id: "hanelore_mini",
                src: _vm.haneloreMini,
                title: "Prinzenpaar 1997/1998",
              },
            }),
            _c(
              "div",
              { staticClass: "titel" },
              [
                _c("ParagraphWide", [
                  _vm._v(" Ex-Prinz Mini I von der Ehrengarde "),
                ]),
                _c("ParagraphWide", [
                  _vm._v(" Ex-Prinzessin Hannelore von Rat und Medien "),
                ]),
              ],
              1
            ),
            _c("Separator"),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "prinzenpaar" },
          [
            _c("TopicHeader", {
              attrs: {
                id: "brigitte_micahel",
                src: _vm.brigitteMichael,
                title: "Prinzenpaar 1986/1987",
              },
            }),
            _c(
              "div",
              { staticClass: "titel" },
              [
                _c("ParagraphWide", [
                  _vm._v(" Ex-Prinz Hans-Michael I von Friedrichstein "),
                ]),
                _c("ParagraphWide", [
                  _vm._v(
                    " Ex-Prinzessin Brigitte-Ursula I von den blauen Pfauen "
                  ),
                ]),
              ],
              1
            ),
            _c("Separator"),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "prinzenpaar" },
          [
            _c("TopicHeader", {
              attrs: {
                id: "giselaRobert",
                src: _vm.giselaRobert,
                title: "Prinzenpaar 1975/1976",
              },
            }),
            _c(
              "div",
              { staticClass: "titel" },
              [
                _c("ParagraphWide", [
                  _vm._v(" Ex-Prinz Robert I von der Paragraphenburg "),
                ]),
                _c("ParagraphWide", [
                  _vm._v(" Ex-Prinzessin Gisela I von Hospitalien "),
                ]),
              ],
              1
            ),
            _c("Separator"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }